import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import vw from 'src/styles/utils';

function CompoundSelect(props) {
  const { label, gridArea, question, required } = props;

  return (
    <Root gridArea={gridArea} {...props}>
      <label htmlFor={question?.id}>{label}</label>
      <select required={required} id={question?.id} name={question?.id} defaultValue={label}>
        <option value=""  />
        {
          question?.options && question.options.map(option => (
            <option value={option.value} key={option.content}>{option.content}</option>
          ))
        }
      </select>
    </Root>
  )
}

CompoundSelect.propTypes = {
  label: PropTypes.string,
  question: PropTypes.object,
  gridArea: PropTypes.string,
  required: PropTypes.bool
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  grid-area: ${props => props.gridArea};

  label {
    font-family: Gotham Book;
    font-style: normal;
    font-weight: normal;
    color: #000000;
    text-align: left;
    ${vw('font-size', 14, 12)}
    ${vw('line-height', 17, 19)}
    ${vw('letter-spacing', 0.06)}
    ${vw('margin-bottom', 5, 3)}
  }
  select {
    border: 1px solid #E1E1E1;
    box-sizing: border-box;
    color: #747474;
    ${vw('height', 30)}
    ${vw('font-size', 8, 12)}
    ${vw('line-height', 10, 16)}
    ${vw('letter-spacing', 0.06)}
    ${vw('padding-left', 3, 5)}
  }
`;

export default CompoundSelect

